import Icon from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const MagicIcon = (props) => {
  const MagicIconSVG = () => {
    const themeDefault = useSelector((state) => state.themeDefault);
    let themeValue = themeDefault?.info?.newConfig;
    const predefinedSizes = {
      small: { ...themeValue?.fontSmlSize?.size },
      medium: { ...themeValue?.fontMediumSize?.size },
      large: { ...themeValue?.fontLgSize?.size },
    };
    const { size, width, height } = props;
    const finalSize = predefinedSizes[size] || { width, height };
    const [changingDegree, setChangingDegree] = useState(0);

    useEffect(() => {
      const updateDegree = () => {
        setChangingDegree((prevDegree) =>
          prevDegree >= 360 ? 0 : prevDegree + 1
        );
      };

      const intervalId = setInterval(updateDegree, 10); // Update every 10ms for smooth transition

      return () => clearInterval(intervalId); // Cleanup interval on component unmount
    }, []);

    const color = `hsl(${changingDegree}deg 86.07% 60.59% / 1)`;

    return (
      <svg
        width={finalSize.width || "30"}
        height={finalSize.height || "30"}
        viewBox="0 0 40 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.94" filter="url(#filter0_d_720_19630)">
          <path
            d="M22.3006 9.27815C22.4686 8.8776 23.0362 8.8776 23.2042 9.27815L24.7888 13.0545C24.8384 13.1729 24.9326 13.2671 25.051 13.3168L28.8274 14.9013C29.2279 15.0693 29.2279 15.6369 28.8274 15.8049L25.051 17.3895C24.9326 17.4391 24.8384 17.5333 24.7888 17.6517L23.2042 21.4281C23.0362 21.8286 22.4686 21.8286 22.3006 21.4281L20.7161 17.6517C20.6664 17.5333 20.5722 17.4391 20.4538 17.3895L16.6774 15.8049C16.2769 15.6369 16.2769 15.0693 16.6774 14.9013L20.4538 13.3168C20.5722 13.2671 20.6664 13.1729 20.7161 13.0545L22.3006 9.27815Z"
            fill="url(#paint0_linear_720_19630)"
          />
        </g>
        <path
          opacity="0.94"
          d="M16.6987 6.08288C16.7739 5.90351 17.0281 5.90351 17.1033 6.08288L18.0193 8.26589C18.0415 8.31891 18.0837 8.36108 18.1367 8.38333L20.3197 9.2993C20.4991 9.37456 20.4991 9.62872 20.3197 9.70398L18.1367 10.6199C18.0837 10.6422 18.0415 10.6844 18.0193 10.7374L17.1033 12.9204C17.0281 13.0998 16.7739 13.0998 16.6987 12.9204L15.7827 10.7374C15.7604 10.6844 15.7183 10.6422 15.6652 10.6199L13.4822 9.70398C13.3029 9.62872 13.3029 9.37456 13.4822 9.2993L15.6652 8.38333C15.7183 8.36108 15.7604 8.31891 15.7827 8.26589L16.6987 6.08288Z"
          fill="url(#paint1_linear_720_19630)"
        />
        <path
          opacity="0.94"
          d="M21.6347 3.34052C21.6878 3.21386 21.8673 3.21386 21.9204 3.34052L22.4256 4.54457C22.4413 4.58201 22.4711 4.61179 22.5085 4.6275L23.7126 5.1327C23.8393 5.18585 23.8393 5.36531 23.7126 5.41846L22.5085 5.92366C22.4711 5.93937 22.4413 5.96915 22.4256 6.00659L21.9204 7.21064C21.8673 7.3373 21.6878 7.3373 21.6347 7.21064L21.1294 6.00659C21.1137 5.96915 21.084 5.93937 21.0465 5.92366L19.8425 5.41846C19.7158 5.36531 19.7158 5.18585 19.8425 5.1327L21.0465 4.6275C21.084 4.61179 21.1137 4.58201 21.1294 4.54457L21.6347 3.34052Z"
          fill="url(#paint2_linear_720_19630)"
        />
        <defs>
          <filter
            id="filter0_d_720_19630"
            x="0.376953"
            y="0.977722"
            width="44.751"
            height="44.7508"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="8" />
            <feGaussianBlur stdDeviation="8" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.882353 0 0 0 0 0.235294 0 0 0 0 0.192157 0 0 0 0.16 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_720_19630"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_720_19630"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_720_19630"
            x1="15.6006"
            y1="15.3531"
            x2="29.9042"
            y2="15.3531"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color={"currentColor"} />
            <stop offset="1" stop-color={"currentColor"} />
          </linearGradient>
          <linearGradient
            id="paint1_linear_720_19630"
            x1="13"
            y1="9.50164"
            x2="20.802"
            y2="9.50164"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color={"currentColor"} />
            <stop offset="1" stop-color={"currentColor"} />
          </linearGradient>
          <linearGradient
            id="paint2_linear_720_19630"
            x1="19.502"
            y1="5.27558"
            x2="24.0531"
            y2="5.27558"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color={"currentColor"} />
            <stop offset="1" stop-color={"currentColor"} />
          </linearGradient>
        </defs>
      </svg>
    );
  };
  return <Icon component={MagicIconSVG} />;
};

export default MagicIcon;
